import {ButtonHTMLAttributes, forwardRef} from 'react'
import {StyledButton} from '@components/ui/button/style.ts'

export type ButtonStyleProps = {
    fullWidth?: boolean
    shape?: 'rectangle' | 'square'
    variant?: 'primary' | 'primaryDanger' | 'secondary' | 'ghost' | 'outlined' | 'tertiary'
    className?: string
    type?: 'button' | 'submit'
}

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & ButtonStyleProps

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
    ({fullWidth, shape = 'rectangle', variant = 'primary', className = '', type = 'button', ...props}, ref) => (
        <StyledButton
            ref={ref}
            $fullWidth={fullWidth}
            $shape={shape}
            $variant={variant}
            className={className}
            type={type}
            {...props}
        />
    )
)
Button.displayName = 'Button'
